import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { ESTADOS_OPORTUNIDAD, API, BASE_URL, OPORTUNIDADES_STATE_SECTION_MAP } from 'CONST';
import { FormGroup, Label, Col, Input, Button } from 'reactstrap';
import { patch, post } from 'helpers/requests';
import PropTypes from 'prop-types';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CheckModal from '../shared/CheckModal';
import WarningModal from '../UI/WarningModal';
import AvanzarOportunidadConfirmationModal from './AvanzarOportunidadConfirmationModal';

const ValidarInformacionSection = ({
  fullData,
  setFullData,
  setInitialSection,
  id,
  estadosOportunidad,
  observaciones,
}) => {
  const history = useHistory();

  const [observacion, setObservacion] = useState('');
  const [observacionesEstado, setObservacionesEstado] = useState([]);
  const [editableSection, setEditableSection] = useState(false);
  const [showUpdateGoodModal, setShowUpdateGoodModal] = useState(false);
  const [showUpdateBadModal, setShowUpdateBadModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [confirmationGoodModal, setConfirmationGoodModal] = useState(false);
  const [confirmationBadModal, setConfirmationBadModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const editableStates = [ESTADOS_OPORTUNIDAD.informacionInicialCargada];

  useEffect(() => {
    if (observaciones) {
      setObservacionesEstado(
        observaciones.filter(
          (obs) => obs.estado.nemotecnico === ESTADOS_OPORTUNIDAD.informacionInicialValidada,
        ),
      );
    }
    if (fullData && fullData.estado && editableStates.includes(fullData.estado.nemotecnico)) {
      setEditableSection(true);
    }
  }, [observaciones, fullData]);

  const postObservacion = (oportunidadResponse = null) => {
    if (observacion) {
      const body = {
        oportunidad_id: id,
        estado_id: estadosOportunidad.find(
          (e) => e.nemotecnico === ESTADOS_OPORTUNIDAD.informacionInicialValidada,
        ).id,
        observacion,
      };
      post(`${BASE_URL}${API.observacionesOportunidad}`, body)
        .catch(() => {
          setShowErrorModal(true);
        })
        .finally(() => {
          if (oportunidadResponse) {
            setFullData(oportunidadResponse);
          }
        });
    } else if (oportunidadResponse) {
      setFullData(oportunidadResponse);
    }
  };

  const validarOportunidad = () => {
    setLoading(true);
    const body = {
      estado_id: estadosOportunidad.find(
        (e) => e.nemotecnico === ESTADOS_OPORTUNIDAD.informacionInicialValidada,
      ).id,
    };
    patch(`${BASE_URL}${API.oportunidadesLinea}${id}/`, body)
      .then((response) => {
        postObservacion(response);
        setInitialSection(OPORTUNIDADES_STATE_SECTION_MAP[response.estado.nemotecnico]);
        setEditableSection(false);
        setShowUpdateGoodModal(true);
      })
      .catch(() => {
        setShowErrorModal(true);
      })
      .finally(() => {
        setConfirmationGoodModal(false);
        setLoading(false);
      });
  };

  const devolverOportunidad = () => {
    setLoading(true);
    const body = {
      estado_id: estadosOportunidad.find(
        (e) => e.nemotecnico === ESTADOS_OPORTUNIDAD.suscriptorAsignado,
      ).id,
    };
    patch(`${BASE_URL}${API.oportunidadesLinea}${id}/`, body)
      .then(() => {
        postObservacion();
        setShowUpdateBadModal(true);
      })
      .catch(() => {
        setShowErrorModal(true);
      })
      .finally(() => {
        setConfirmationBadModal(false);
        setLoading(false);
      });
  };

  return (
    <div>
      <FormGroup row>
        <Col sm={2}>
          <Label>Observaciones</Label>
        </Col>
        <Col>
          <Input
            id="observacion-info-inicial"
            type="textarea"
            value={
              !editableSection && observacionesEstado.length > 0
                ? observacionesEstado[0].observacion
                : observacion || ''
            }
            onChange={(event) => setObservacion(event.target.value)}
            rows="3"
            disabled={!editableSection}
          />
        </Col>
      </FormGroup>
      {observacionesEstado.slice(!editableSection).map((obs) => {
        return (
          <FormGroup row key={obs.id}>
            <Col sm={2} />
            <Col>
              <Input type="textarea" value={obs.observacion} rows="3" disabled />
            </Col>
          </FormGroup>
        );
      })}
      {editableSection && (
        <div className="button-container d-flex justify-content-end">
          <Button
            className="btn btn-secondary warning-cancel no-bold"
            style={{ marginRight: 25 }}
            onClick={() => setConfirmationBadModal(true)}
            disabled={confirmationBadModal || confirmationGoodModal}
          >
            {loading && confirmationBadModal ? (
              <FontAwesomeIcon spin={loading} icon={faSpinner} />
            ) : (
              'Solicitar Revisión Información Inicial'
            )}
          </Button>
          <Button
            className="btn btn-secondary warning-accept no-bold"
            onClick={() => setConfirmationGoodModal(true)}
            disabled={confirmationBadModal || confirmationGoodModal}
          >
            {loading && confirmationGoodModal ? (
              <FontAwesomeIcon spin={loading} icon={faSpinner} />
            ) : (
              'Validar Información Oportunidad'
            )}
          </Button>
        </div>
      )}
      <CheckModal
        isOpen={showUpdateGoodModal}
        toggle={() => setShowUpdateGoodModal(false)}
        handleOk={() => setShowUpdateGoodModal(false)}
        okBtnText="OK"
        confirmMsg="Información inicial validada exitosamente."
      />
      <AvanzarOportunidadConfirmationModal
        openModal={confirmationGoodModal}
        setOpenModal={setConfirmationGoodModal}
        avanzarOportunidad={validarOportunidad}
        loading={loading}
      />
      <CheckModal
        isOpen={showUpdateBadModal}
        toggle={() => history.push('/garantia/oportunidades')}
        handleOk={() => history.push('/garantia/oportunidades')}
        okBtnText="OK"
        confirmMsg="Oportunidad devuelta a estado anterior."
      />
      <AvanzarOportunidadConfirmationModal
        openModal={confirmationBadModal}
        setOpenModal={setConfirmationBadModal}
        avanzarOportunidad={devolverOportunidad}
        mensajeModal="¿Está seguro que desea RETROCEDER esta oportunidad?"
        loading={loading}
      />
      <WarningModal
        isOpen={showErrorModal}
        toggle={() => setShowErrorModal(false)}
        handleClearError={() => setShowErrorModal(false)}
        errorMsg="Ha ocurrido un error al cargar la información inicial."
        loading={false}
        onlyCancelButton
      />
    </div>
  );
};

ValidarInformacionSection.propTypes = {
  id: PropTypes.string,
  fullData: PropTypes.shape({
    actualizacion_ts: PropTypes.string,
    afianzado: PropTypes.shape({
      id: PropTypes.number,
      nombre: PropTypes.string,
      rut: PropTypes.string,
    }),
    afianzado_id: PropTypes.number,
    creacion_ts: PropTypes.string,
    estado: PropTypes.shape({
      descripcion: PropTypes.string,
      id: PropTypes.number,
      nemotecnico: PropTypes.string,
    }),
    id: PropTypes.number,
    monto: PropTypes.number,
    responsable_id: PropTypes.number,
    suscriptor_id: PropTypes.number,
  }),
  setFullData: PropTypes.func.isRequired,
  setInitialSection: PropTypes.func.isRequired,
  estadosOportunidad: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      nemotecnico: PropTypes.string,
      descripcion: PropTypes.string,
    }),
  ),
  observaciones: PropTypes.arrayOf(
    PropTypes.shape({
      actualizacion_ts: PropTypes.string,
      creacion_ts: PropTypes.string,
      estado: PropTypes.shape({
        descripcion: PropTypes.string,
        id: PropTypes.number,
        nemotecnico: PropTypes.string,
      }),
      id: PropTypes.number,
    }),
  ),
};

ValidarInformacionSection.defaultProps = {
  fullData: null,
  id: null,
  estadosOportunidad: [],
  observaciones: [],
};

export default ValidarInformacionSection;
